import { ContainerApp, ContentApp, FooterApp, HeaderApp } from './Layout.app'
import { TurnoCard } from './TurnoCard.app'
import { useMyTurnosPaciente } from '../data/hooks/useTurnos.hook'
import { TurnosFilter } from '../data/types/turnos.type'
import { useNavigate } from 'react-router-dom'
import { ButtonInApp } from './ButtonInApp.component'

export const TurnosPendientesApp = () => {
	const { data: turnos, isLoading, error } = useMyTurnosPaciente(TurnosFilter.PENDIENTES)
	const navigate = useNavigate()

	const handleBack = () => {
		navigate('/app/menu')
	}

	return (
		<ContainerApp>
			<HeaderApp title="Pendientes" />
			<ContentApp>
				{turnos?.sort((a, b) => {
					const fechaComparison = new Date(b.fecha).getTime() - new Date(a.fecha).getTime();
					if (fechaComparison !== 0) return fechaComparison;
					return b.hora.localeCompare(a.hora);
				}).map((turno) => (
					<TurnoCard key={turno.id} turno={turno} />
				))}
			</ContentApp>
			<FooterApp>
				<ButtonInApp 
					label="Atrás"
					onClick={handleBack}
					type="button" 
				/>
			</FooterApp>
		</ContainerApp>
	)
}